import { message, Table } from 'antd';
import TcShowLocationModal from 'components/UI/Map/showLocationModal/TcShowLocationModal';
import endpointUrls from 'global/Constants/endpointUrls';
import { handleApiThen, handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import { localApiCatcher } from 'global/helperFunctions/localApiCatcher';
import { IBackendGetGeneric } from 'global/Models/globalModels';
import { inqueryKiosk, inqueryLocker, userAccessibleLKiosk } from 'global/Models/lockerModel';
import { lockerInfo, packageCreate } from 'global/Models/omOrderModel';
import OmParcelOrderModel from 'global/Models/omParcelOrderModel';
import ApiService, { errorResponse } from 'global/utils/ApiService';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
interface IProps {
  userAccessibleKiosksList: IBackendGetGeneric<userAccessibleLKiosk> | undefined;
  loading: boolean;
  setLockerAddress?: (_locker: lockerInfo) => void;
  cityId?: number;
  packages: packageCreate[] | undefined;
  index: number;
  handleClose?: () => void;
}

const UserAccessibleKiosksTable: FC<IProps> = ({ userAccessibleKiosksList, setLockerAddress, cityId, packages, index, handleClose }) => {
  // state
  const [loading, setLoading] = useState<boolean>(false);
  const [_inqueryKioskloading, setInqueryKioskloading] = useState<boolean>(false);

  const [selectedLocation, setSelectedLocation] = useState<{ lat: number; lng: number }>();
  const omOrderReservedByLocker = useSelector((state: RootState) => state.parcelOrder.omOrderReservedByLocker);

  //function
  const reserveLocker = async (locker: inqueryLocker): Promise<boolean> => {
    if (!cityId) return false;
    if (!packages) return false;
    await ApiService.post(endpointUrls.lockerInsertOrder, {
      lockerId: locker.id,
      sourceCityId: packages[0].sourceCity?.id,
      destinationCityId: packages[0].destinationCity?.id,
    }).then((res: any) => {
      // This API returns { status: 0, order: {...} } — normalize for handleApiThen
      handleApiThen({
        res,
        onSuccess: () => {
          // dispatch(setOmOrderReservedByLocker(res.order));
          setLockerAddress &&
            setLockerAddress({
              orderNumber: res?.data?.order?.orderNumber,
              locker,
              cityId,
            });
        },
        notifFail: true,
        notifSuccess: true,
      });
    });

    return true;
  };

  const callReservationForEachLocker = async (lockersList: inqueryLocker[]) => {
    setLoading(true);

    for (let i = 0; i < lockersList?.length; i++) {
      const locker = lockersList[i];
      const isSuccess = await reserveLocker(locker);
      if (isSuccess) {
        setLoading(false);
        handleClose && handleClose();
        break;
      }

      if (i === lockersList.length - 1) {
        message.error('تمام قفسه های این کیوسک قبلا رزرو شده است. لطفا چند لحظه دیگر امتحان کنید.');
        setLoading(false);
      }
    }
  };

  const callInquiryKioskForGettingEmptyLockers = async (bunchId: number) => {
    if (!packages) return;
    setInqueryKioskloading(true);
    const pack = packages ? packages[index] : ({} as packageCreate);
    // How It Works:
    // The code iterates over each package in the pack array, creating objects with dimensions and weight. If count is 1, a single object is added; otherwise, multiple objects are added based on count.
    const payload = {
      dimensions: pack.package.flatMap((pkg) => {
        const { width, height, length, weight, count } = pkg;
        if (!count || count < 2) {
          return [{ width, height, length, weight }];
        } else {
          return Array.from({ length: count }, () => ({ width, height, length, weight }));
        }
      }),
    };
    await ApiService.post(endpointUrls.lockerInqueryBunch, {
      sourceCityId: packages[index].sourceCity?.id,
      destinationCityId: packages[index].destinationCity?.id,
      bunchId,
      ...payload,
    })
      .then((res: IBackendGetGeneric<inqueryKiosk>) =>
        handleApiThenGeneric<IBackendGetGeneric<inqueryKiosk>, inqueryKiosk>({
          res,
          onSuccessData: (data) => {
            callReservationForEachLocker(data.lockers);
          },
          notifFail: true,
          notifSuccess: false,
          // onFailed: () => message.error('خطا در دریافت لیست لاکرهای این کیوسک'),
        })
      )
      .catch(() => localApiCatcher(errorResponse));
    setInqueryKioskloading(false);
  };

  //constant
  const kioskList = userAccessibleKiosksList?.data?.bunches;

  if (!cityId) return null;

  return (
    <>
      {userAccessibleKiosksList && kioskList && !omOrderReservedByLocker && (
        <div className='mt-5'>
          {/* <TcDevider> لیست کیوسک های مجاز در محدوده شما</TcDevider> */}
          <Table
            dataSource={userAccessibleKiosksList.data.bunches}
            columns={OmParcelOrderModel.columns(callInquiryKioskForGettingEmptyLockers, setSelectedLocation)}
            pagination={{
              pageSize: 20,
              total: userAccessibleKiosksList.data.bunches.length,
            }}
            loading={loading}
          />
        </div>
      )}
      {/* <ReservedLockerContent orderReservationData={omOrderReservedByLocker} /> */}
      <TcShowLocationModal location={selectedLocation} close={() => setSelectedLocation(undefined)} />
    </>
  );
};

export default UserAccessibleKiosksTable;
